
const HeightType = Symbol();

export class Height {
    [HeightType]: any;
    readonly value: string;

    private constructor(height: number | string) {
        this.value = String(height);
    }

    static from(height: number | string): Height {
        return new Height(height);
    }

    static fromNothing(): Height {
        return new Height("");
    }
}
